// extracted by mini-css-extract-plugin
module.exports = {"cta":"_36tAUD16","disabled":"_3WBTnDTj","primary":"_2V78GhpA","transparent":"_2yC5rOfE","secondary":"_1asdLRoS","fullWidth":"_3dnigQI9","small":"FmtjlvnI","spinner":"_1Zxxzdjp"};